import type { ToteEngagementMode } from '@mote/api'

export enum ToteCardMode {
  INITIAL = 'initial',
  AWAITING = 'awaiting',
  RESPONSE = 'response',
  TEPLY = 'teply'
}

export type ToteEngagementModeWithAwaiting =
  | ToteEngagementMode
  | ToteCardMode.AWAITING

export type TeplyData = {
  title: string
  placeholder: string
  mode: ToteEngagementMode | null
  onSkip: () => void
  onSubmit: (text: string) => void
}

export type ResponseData = {
  mode: ToteEngagementMode | null
}

export type AwaitingData = {
  mode: 'awaiting'
}

export type ToteData = {
  [ToteCardMode.TEPLY]: TeplyData
  [ToteCardMode.RESPONSE]: ResponseData
  [ToteCardMode.AWAITING]: AwaitingData
}

export type ToteDataReturn<T extends keyof ToteData> = ToteData[T]
